import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AlertStateFacade } from '@zero/shared/util-global-state';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { ContractConfirmationServiceBase } from '../services/contract-confirmation.service';

export const contractConfirmationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const service: ContractConfirmationServiceBase = inject(ContractConfirmationServiceBase);
  const alert: AlertStateFacade = inject(AlertStateFacade);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        const { error: customError, status } = error;
        const isStatusNotAcceptable = status === 406;
        const isContractConfirmationRequired = isStatusNotAcceptable && 'CONTRACT_CONFIRMATION_REQUIRED' === customError.errorCode;
        if (isContractConfirmationRequired) {
          service.displayDialog();
          return EMPTY;
        }

        const isUserSuspended = isStatusNotAcceptable && 'USER_SUSPENDED' === customError.errorCode;
        if (isUserSuspended) {
          alert.addErrorAlert({
            message: customError.message,
          });
          return EMPTY;
        }
      }
      return throwError(() => error);
    }),
  );
};
